import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {GoogleMapsAPIWrapper, MapsAPILoader} from '@agm/core';
import { GeolocationdistancePipe } from '../../filter/geolocationdistance.pipe';
import { AgmCoreModule } from '@agm/core';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnInit {
  lon: any;
  lat: any;
  marker: any;
  constructor(private dialogRef: MatDialogRef <MapComponent>,  @Inject(MAT_DIALOG_DATA) public data: any ) {
    this.lat = data.lat;
    this.lon = data.lon;
    this.setMarker();
   }

  ngOnInit() {
  }
  setMarker() {
    this.marker = {'lat': this.lat, 'lon': this.lon};
  }
  OnChangeMarker(event: any) {
    this.marker = {'lat': event.coords.lat, 'lon': event.coords.lng};
  }
  setMarkerLocation() {
    const result = this.marker;
    this.dialogRef.close(result);
    }
}
